import Assets from "./Assets.jsx";

export default Assets;
